import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { ToasterService } from '../_services/toaster.service';
import { Title } from '@angular/platform-browser';
import { LoaderService } from '../_services/loader.service';
import { CanonicalService } from '../shared/canonical.service';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css'],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    // private httpClient: HttpClient,
    // tslint:disable-next-line: variable-name
    private _global: Globals,
    private toastr: ToasterService,
    private canonicalService: CanonicalService,
    private loader: LoaderService) { }

  Registration: any = {};
  emailPattern = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
  // tslint:disable-next-line: member-ordering
  PasswordDontMatch = false;
  // tslint:disable-next-line: member-ordering
  IsFormValid = false;
  // tslint:disable-next-line: member-ordering
  UserNameTakenError = false;
  UserEmailTakenError = false;
  ngOnInit() {
    this.titleService.setTitle('Registration | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
    // tslint:disable-next-line: variable-name
    const _localStorage = JSON.parse(localStorage.getItem('currentUser'));
    if (_localStorage) {
      this.router.navigate(['/property/submit']);
    }
  }

  ConfirmPassword() {
    // tslint:disable-next-line: triple-equals
    if (this.Registration.RegPassword != this.Registration.RegConfirmPassword) {
      this.PasswordDontMatch = true;
      return;
    } else {
      this.PasswordDontMatch = false;
    }
  }

  Register() {
    if (this.PasswordDontMatch) {
      return;
    }
    this.loader.showLoader();
    // tslint:disable-next-line: max-line-length
    this.UserRegistration(this.Registration.FirstName, this.Registration.LastName, this.Registration.RegUserName, this.Registration.RegEmail, this.Registration.RegPassword, this.Registration.RegConfirmPassword)
      .subscribe(result => {
        if (result.IsSuccess) {
          this.toastr.Success('Welcome to pakmatti.com', result.Message);
          this.router.navigate(['/registration/information']);
        } else {
          this.toastr.Error(result.Message);
        }
        this.loader.hideLoader();
    });
  }

  clearTextBox_After_Regester() {
    this.Registration.RegConfirmPassword = '';
    this.Registration.RegPassword = '';
    this.Registration.RegEmail = '';
    this.Registration.RegUserName = '';
  }

  public UserRegistration(firstName, lastName, userName, Email, Password, ConfirmPassword): Observable<any> {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    // const url = `${this._global.apiUrl}Account/Register`;
    // // tslint:disable-next-line: max-line-length
    // const body = JSON.stringify({ FirstName: firstName, LastName: lastName, UserName: userName, Email, Password, ConfirmPassword });
    // return this.httpClient.post(url, body, headers);
    return;
  }
  UserCredentialsfocusOutService(parameter: any, Control: string) {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    let url;
    // tslint:disable-next-line: triple-equals
    if (Control == 'userName') {
     url = `${this._global.apiUrl}Account/IsUserNameAvailable?userName=` + parameter;
    }
    // tslint:disable-next-line: triple-equals
    if (Control == 'emailAddress') {
      url =  `${this._global.apiUrl}Account/IsEmailRegistered?emailAddress=` + parameter;
    }

    // return this.httpClient.post(url, headers);
    return;
  }

  UserNamefocusOut(UserName: any) {
    // tslint:disable-next-line: triple-equals
    if (UserName != undefined && UserName != null && UserName.length > 0 ) {
      // this.UserCredentialsfocusOutService(UserName, 'userName').subscribe(x => {
      //   // tslint:disable-next-line: triple-equals
      //   if (x == false) {

      //     this.IsFormValid = false;
      //     this.UserNameTakenError = true;
      //   } else {
      //     this.IsFormValid = true;
      //     this.UserNameTakenError = false;
      //   }
      // });
    }
  }
  UserEmailfocusOut(UserEmail: any) {
    // tslint:disable-next-line: triple-equals
    if (UserEmail != undefined && UserEmail != null && UserEmail.length >= 5) {
    //   this.UserCredentialsfocusOutService(UserEmail, 'emailAddress').subscribe(x => {
    //     // tslint:disable-next-line: triple-equals
    //     if (x == false) {

    //       this.IsFormValid = false;
    //       this.UserEmailTakenError = true;
    //     } else {
    //       this.IsFormValid = true;
    //       this.UserEmailTakenError = false;
    //     }
    //   });
     }
  }
}
